module.exports = __webpack_public_path__ + "static/media/Banner_WORKSHOP_2.4d3a9857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/Banner_WORKSHOP_2.png
// module id = 210
// module chunks = 0